// export const baseURL = `http://localhost:8080/api`
// export const socketApiUrl =`http://localhost:8080/socket`


// export const baseURL =`https://3c-static-backend.vercel.app/`
// export const baseURL=`https://www.3cchain.io/api/`

export const baseURL =`https://ico.vunecoin.com/api`
export const socketApiUrl =`https://ico.vunecoin.com/socket`